import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { mergeWith, MergeWithCustomizer } from 'lodash'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { ProjectModel } from 'model/ProjectModel'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

const keepLatestSourceArrayValue: MergeWithCustomizer = (
  value,
  srcValue,
  key
) => {
  if (Array.isArray(value) || key === 'tokens') {
    return srcValue
  }
}

const fullReplacer: MergeWithCustomizer = (value, srcValue) => {
  return srcValue
}

export const bomItemReplacer: CaseReducer<
  ProjectState,
  PayloadAction<
    {
      replacementBehaviour?:
        | 'keepLatestSourceIfArrayOrToken'
        | 'default'
        | 'fullReplace'
    } & Partial<PartTypeRow>
  >
> = (state, action) => {
  if (!action.payload) {
    return state
  }

  const {
    replacementBehaviour = 'keepLatestSourceIfArrayOrToken',
    ...rowProperties
  } = action.payload

  let replacementStrategy = null

  switch (replacementBehaviour) {
    case 'keepLatestSourceIfArrayOrToken':
      replacementStrategy = keepLatestSourceArrayValue
      break
    case 'fullReplace':
      replacementStrategy = fullReplacer
      break
    default:
      replacementStrategy = null
  }

  const bomItem =
    (state.flatView && state.flatView[action.payload.id]) ||
    (state.treeView && state.treeView[action.payload.id])

  if (!bomItem) return state

  if (bomItem.type === 'AssemblyHeader') {
    mergeWith(
      bomItem,
      {
        assembly: { ...rowProperties },
      },
      replacementStrategy
    )
  } else {
    mergeWith(bomItem, rowProperties, replacementStrategy)
  }

  return state
}

export const activeProjectReplacer: CaseReducer<
  ProjectState,
  PayloadAction<Partial<ProjectModel>>
> = (state, action) => {
  if (!action.payload) {
    return state
  }

  mergeWith(state.activeProject, action.payload, keepLatestSourceArrayValue)

  return state
}

export const projectStateReplacer: CaseReducer<
  ProjectState,
  PayloadAction<Partial<ProjectState>>
> = (state, action) => {
  if (!action.payload) {
    return state
  }

  mergeWith(state, action.payload, keepLatestSourceArrayValue)

  return state
}
